import ApexChart from "react-apexcharts";

import "./style.css";

function ChartLine(props) {
	const options = {
		xaxis: {
			type: "category",
			categories: [["Total", ""], ["Finalizado"], ["Pendente"], ["Atrasados", ""]],
			tickAmount: undefined,
			tickPlacement: "between",
			min: undefined,
			max: undefined,
			range: undefined,
			floating: false,
			decimalsInFloat: undefined,
			overwriteCategories: undefined,
			position: "bottom",
			labels: {
				show: true,
				rotate: -45,
				rotateAlways: false,
				hideOverlappingLabels: true,
				showDuplicates: false,
				trim: false,
				minHeight: undefined,
				maxHeight: 120,
				style: {
					colors: [],
					fontSize: 12,
					fontFamily: "Poppins, Arial, sans-serif",
					fontWeight: 400,
					cssClass: "",
				},
				offsetX: 0,
				offsetY: -4,
				format: undefined,
				formatter: undefined,
				datetimeUTC: true,
				datetimeFormatter: {
					year: "yyyy",
					month: "MMM 'yy",
					day: "dd MMM",
					hour: "HH:mm",
				},
			},
			crosshairs: {
				show: true,
				width: 1,
				position: "back",
				opacity: 0.9,
				stroke: {
					color: "#b6b6b6",
					width: 0,
					dashArray: 0,
				},
				fill: {
					type: "solid",
					color: "#B1B9C4",
					gradient: {
						colorFrom: "#D8E3F0",
						colorTo: "#BED1E6",
						stops: [0, 100],
						opacityFrom: 0.4,
						opacityTo: 0.5,
					},
				},
			},
			// tooltip: {
			// 	enabled: true,
			// 	formatter: undefined,
			// 	offsetY: 0,
			// 	style: {
			// 		fontSize: 0,
			// 		fontFamily: 0,
			// 	},
			// },
		},
		yaxis: {
			show: true,
			showAlways: true,
			showForNullSeries: false,
			seriesName: undefined,
			opposite: true,
			reversed: false,
			logarithmic: false,
			logBase: 10,
			// tickAmount: 6,
			// min: 6,
			// max: 6,
			forceNiceScale: false,
			floating: false,
			decimalsInFloat: undefined,
			labels: {
				show: true,
				align: "right",
				minWidth: 0,
				maxWidth: 160,
				style: {
					colors: [],
					fontSize: "12px",
					fontFamily: "Poppins, sans-serif",
					fontWeight: 600,
					cssClass: "apexcharts-yaxis-label",
				},
				offsetX: 0,
				offsetY: 0,
				rotate: 0,
				// formatter: (value) => {
				// 	return val;
				// },
			},
			axisBorder: {
				show: true,
				color: "#78909C",
				offsetX: 0,
				offsetY: 0,
			},
			axisTicks: {
				show: true,
				borderType: "solid",
				color: "#78909C",
				width: 6,
				offsetX: 0,
				offsetY: 0,
			},
			title: {
				text: undefined,
				rotate: -90,
				offsetX: 0,
				offsetY: 0,
				style: {
					color: undefined,
					fontSize: "12px",
					fontFamily: "Poppins, sans-serif",
					fontWeight: 600,
					cssClass: "apexcharts-yaxis-title",
				},
			},
			crosshairs: {
				show: true,
				position: "back",
				stroke: {
					color: "#b6b6b6",
					width: 1,
					dashArray: 0,
				},
			},
			tooltip: {
				enabled: true,
				offsetX: 0,
			},
		},
		// title: {
		// 	text: "Entradas e Saídas",
		// 	align: "left",
		// },
		plotOptions: {
			bar: {
				horizontal: false,
				borderRadius: 6,
				borderRadiusApplication: "end",
				borderRadiusWhenStacked: "last",
				columnWidth: "80%",
				barHeight: "80%",
				distributed: false,
				rangeBarOverlap: true,
				rangeBarGroupRows: false,
				colors: {
					ranges: [
						{
							from: 0,
							to: 0,
							color: undefined,
						},
					],
					backgroundBarColors: [],
					backgroundBarOpacity: 1,
					backgroundBarRadius: 0,
				},
				dataLabels: {
					position: "top",
				},
			},
		},
		//label que fica nas barras
		dataLabels: {
			enabled: false,
			style: {
				colors: ["#fff"],
				fontSize: "8px",
				fontWeight: "bold",
			},
			dropShadow: {
				enabled: true,
				left: 2,
				top: 2,
				opacity: 0.5,
			},
			background: {
				enabled: true,
				foreColor: "#fff",
				borderRadius: 2,
				padding: 4,
				opacity: 0.9,
				borderWidth: 1,
				borderColor: "#fff",
			},
			offsetX: 0,
		},
		grid: {
			show: true,
			xaxis: {
				lines: {
					show: true,
				},
			},
		},
		//cores das barras
		colors: ["#3b8f65", "#c40515"],
		// colors: ["#129c59", "#6a282e"],

		// fill: {
		// 	type: "gradient",
		// 	gradient: {
		// 		shade: "dark",
		// 		type: "vertical",
		// 		shadeIntensity: 0.5,
		// 		gradientToColors: ["#42df90", "#e63141"],
		// 		inverseColors: true,
		// 		opacityFrom: 1,
		// 		opacityTo: 1,
		// 		stops: [0, 100],
		// 	},
		// },
	};

	const series = [
		{
			name: "Receitas",
			data: [props.receitas, props.receitasPagas, props.receitasAReceber + props.receitasAtrasadas, props.receitasAtrasadas],
		},
		{
			name: "Despesas",
			data: [props.despesas, props.despesasPagas, props.despesasAReceber + props.despesasAtrasadas, props.despesasAtrasadas],
		},
	];

	return (
		<>
			{props.loading ? (
				<div className="loading text-center h-100 m-5">
					<div>
						<span className="spinner-grow spinner-grow-sm text-primary me-2" role="status"></span>
						<span className="text-primary">Buscando Dados...</span>
					</div>
				</div>
			) : (
				<ApexChart //
					options={options}
					series={series}
					type="bar"
					// width={800}
					height={400}
				/>
			)}
		</>
	);
}

export default ChartLine;

// function ChartLine() {
// 	const options = {
// 		xasis: {
// 			type: "datetime",
// 		},
// 		yasix: {
// 			tooltip: {
// 				enabled: true,
// 			},
// 		},
// 	};

// 	const series = [
// 		{
// 			data: [
// 				{
// 					x: new Date(1538778600000),
// 					y: [6629.81, 6650.5, 6623.04, 6633.33],
// 				},
// 			],
// 		},
// 	];

// 	return (
// 		<div className="">
// 			<h1>Gráfico</h1>
// 			<ApexChart //
// 				options={options}
// 				series={series}
// 				type="candlestick"
// 				width={640}
// 				height={480}
// 			/>
// 			;<h1>Gráfico</h1>
// 		</div>
// 	);
// }

// export default ChartLine;
